import React from "react";
import _ from "lodash";
import moment from "moment-timezone";
import Select from "react-select";
import { NetworkAPI } from "apis";

import LoadingUI from "components/common/LoadingUI";
import SimpleTooltip from "components/common/SimpleTooltip";
import PromptModal from "components/common/PromptModal";
import SimpleDataTable from "components/common/SimpleDataTable";
import VirtualPlacementSelector from "components/common/VirtualPlacementSelector";
import { transformGamUprToUprConfig } from "components/network/pricing-rules/gam-upr/GamUprHelper";

import UnitsSelector from "../../../common/UnitsSelector";
import CustomSetTargetingControlV2 from "../../../control-center/auto-pilot/config/CustomSetTargetingControlV2";
import PricingSectionControl from "./PricingSectionControl";
import TargetingWithInExControl from "./TargetingWithInExControl";
import BrandedPriceSettingsSection from "./BrandedPriceSettingsSection";
import NetworkPlacementModal from "./NetworkPlacementModal";

import { buttonActionClass, buttonActionClassGray } from "helpers/StyleClass";

import { MODAL_TYPE } from "../custom-first-look/Constants";

import { FaCheck, FaTimes } from "react-icons/fa";
import { MESSAGE } from "constants/Message";

const inputClass =
  "bg-white flex w-full border border-gray-400 rounded py-1 px-3 appearance-none leading-normal focus:outline-none focus:border-blue-400 focus:shadow-inner hover:border-gray-500";
const inputClassDisabled =
  "bg-gray-300 flex w-full border border-gray-400 rounded py-1 px-3 appearance-none leading-normal";

const targetingBlockClass = "border p-2 my-2 bg-white";
const targetingTitleClass = "block text-gray-800 font-bold mb-1"; //"font-semibold";

// Important! not snake case!!!!!!! snake case is in apconfig
const TARGETING_TYPE = {
  OS: "os",
  DC: "deviceCategory",
  COUNTRY: "country",
  BROWSER: "browser",
  CUSTOMS: "customs",
  // INVENTORY: "inventory",
  INVENTORY_TYPES: "inventoryTypes",
  INVENTORY_URL: "inventoryUrl",
  VIDEO_POSITIONS: "videoPositions",
  INVENTORY_FORMAT: "inventoryFormat",
  MOBILE_APPLICATION: "mobileApplication",
};

function getSuggestNextId(ids) {
  if (!ids.length) return 1;

  const sorted = [...ids].sort((a, b) => a - b);

  let bestLen = 0;
  let bestEnd = 0;

  let currLen = 1;

  for (let i = 1; i < sorted.length; i++) {
    if (sorted[i] === sorted[i - 1] + 1) {
      currLen++;
    } else {
      if (currLen >= 2 && currLen > bestLen) {
        bestLen = currLen;
        bestEnd = sorted[i - 1];
      }
      currLen = 1;
    }
  }

  if (currLen >= 2 && currLen > bestLen) {
    bestLen = currLen;
    bestEnd = sorted[sorted.length - 1];
  }

  return bestLen >= 2 ? bestEnd + 1 : sorted[sorted.length - 1] + 1;
}

class NetworkCustomUPRForm extends React.Component {
  constructor(props) {
    super(props);

    let { uprSetting, importIdList } = props;

    const {
      id = "",
      name = "",
      label = "",
      priceSection = {},
      targetingSection = {},
    } = uprSetting;

    let placementIdsString = _.get(
      targetingSection,
      ["inventory", "placementIds"],
      [],
    ).join(",");

    this.state = {
      id,
      name,
      label,
      priceSection,
      targetingSection,
      placementIdsString,

      importUprId: "", // manually import
      importErrMsg: null,
      isLoading: true,

      importUprIdList: importIdList, // import from query string
      importUprIdOptions: [],
      autoImport: null,
      selectedId: "",
      importData: {},
      isBatch: false,
      isOpenPlacementModal: false,

      idCheckResult: null,
    };

    this.handleCheckId = this.handleCheckId.bind(this);
    this.handleChange = this.handleChange.bind(this);
    this.handleTargetingChanged = this.handleTargetingChanged.bind(this);
    this.handleInventoryUnitsChanged =
      this.handleInventoryUnitsChanged.bind(this);
    this.handleInventoryExcludeUnitsChanged =
      this.handleInventoryExcludeUnitsChanged.bind(this);
    this.handlePlacementIdsChanged = this.handlePlacementIdsChanged.bind(this);
    this.handlePlacementSelect = this.handlePlacementSelect.bind(this);
    this.handleVirtualPlacementIdsChanged =
      this.handleVirtualPlacementIdsChanged.bind(this);
    this.handlePriceTypeChanged = this.handlePriceTypeChanged.bind(this);
    this.handlePriceChanged = this.handlePriceChanged.bind(this);
    this.handleBrandPriceSettingsChanged =
      this.handleBrandPriceSettingsChanged.bind(this);

    this.handleImportUprIdChanged = this.handleImportUprIdChanged.bind(this);
    this.handleImportUpr = this.handleImportUpr.bind(this);
    this.handleSelectChanged = this.handleSelectChanged.bind(this);

    this.handleUpdate = this.handleUpdate.bind(this);
    this.handleLoading = this.handleLoading.bind(this);
  }

  async componentDidMount() {
    if (this.props.modalType === MODAL_TYPE.ADD) {
      const { cstConfig } = await NetworkAPI.getCstConfig({
        networkId: this.props.networkId,
      });

      let autoImport = null;
      if (
        cstConfig &&
        cstConfig.general &&
        cstConfig.general.key &&
        cstConfig.general.managedValues
      ) {
        autoImport = {
          keyId: cstConfig.general.key.id.toString(),
          valueIds: cstConfig.general.managedValues.map((v) => v.id.toString()),
          operator: "IS",
        };
      }

      if (this.state.importUprIdList && this.state.importUprIdList.length > 0) {
        const firstId = this.state.importUprIdList[0];

        this.setState(
          {
            isBatch: true,
            selectedId: firstId,
            importUprIdOptions: this.props.importIdList.map((id) => ({
              value: id,
              label: id,
            })),
            autoImport,
          },
          () => {
            this.handleImportUpr(firstId);
          },
        );
      } else {
        const idList = this.props.ruleList.map((rule) => rule.id);
        const nextId = getSuggestNextId(idList);
        this.setState(
          {
            autoImport,
            targetingSection: this._addAutoImport(
              this.state.targetingSection,
              autoImport,
            ),
            id: nextId,
            idCheckResult: true,
          },
          () => {
            this.handleUpdate("id", this.state.id);
            this.handleUpdate("targetingSection", this.state.targetingSection);
            this.handleLoading(false);
          },
        );
      }
    } else {
      this.handleLoading(false);
    }
  }

  componentDidUpdate(prevProps) {
    if (!_.isEqual(prevProps.importIdList, this.props.importIdList)) {
      this.setState(
        {
          importUprIdOptions: this.state.importUprIdOptions.filter(
            (option) => this.props.importIdList.indexOf(option.value) !== -1,
          ),
        },
        () => {
          this.handleSelectChanged(this.state.importUprIdOptions[0]);
        },
      );
    }
  }

  handleImportUprIdChanged(e) {
    this.setState({ importUprId: e.target.value, importErrMsg: null });
  }

  async handleImportUpr(importUprId) {
    try {
      this.handleLoading(true);
      const { networkId } = this.props;
      const { importData, isBatch, autoImport } = this.state;

      let uprSetting = importData[importUprId];
      if (!uprSetting || !isBatch) {
        const r = await NetworkAPI.getGamUpr({ networkId, uprId: importUprId });
        if (!r.externalId) {
          throw new Error("No UPR found");
        }

        const importedUpr = _transformToUprSetting({ gamUpr: r });
        const targetingSection = autoImport
          ? this._addAutoImport(importedUpr.targetingSection, autoImport)
          : _.cloneDeep(importedUpr.targetingSection);

        uprSetting = {
          enabled: true,
          priceSection: importedUpr.priceSection,
          targetingSection,
          name: `${importedUpr.uprName} (imported at ${moment().format(
            "YYYY-MM-DD HH:mm:ss Z",
          )})`,
          label: "Imported",
          id: _.parseInt(importedUpr.externalId) + 10000000000,
        };
      }

      function _transformToUprSetting({ gamUpr }) {
        // priceSection
        // targetingSection
        /// extras that custom upr doesnt support yet (eg. inventoryUrl)
        // inventoryUrl support in PR #995

        const transformedUpr = transformGamUprToUprConfig({ gamUpr });
        console.log("transformedUpr", transformedUpr);
        console.log("gamUpr", gamUpr);

        return transformedUpr; //gamUpr;
      }

      const {
        id = "",
        name = "",
        label = "",
        priceSection = {},
        targetingSection = {},
      } = uprSetting;

      let placementIdsString = _.get(
        targetingSection,
        ["inventory", "placementIds"],
        [],
      ).join(",");

      const cloneData = _.cloneDeep(importData);

      this.setState(
        {
          id,
          name,
          label,
          priceSection,
          targetingSection,
          placementIdsString,
          importErrMsg: null,
          importUprId,
          importData: {
            ...cloneData,
            [importUprId]: uprSetting,
          },
          idCheckResult: this.handleCheckId(id),
        },
        () => {
          if (!this.props.handleCurrentRuleChanged) return;
          if (isBatch) {
            this.props.handleCurrentRuleChanged({
              ...uprSetting,
              importId: importUprId,
            });
          } else {
            this.props.handleCurrentRuleChanged(uprSetting);
          }

          this.handleLoading(false);
        },
      );
    } catch (err) {
      console.log(err, err.toString());
      this.setState({ importErrMsg: err.toString() });
      this.handleLoading(false);
    }
  }

  handleCheckId(id) {
    if (typeof id === "string") {
      if (_.isEmpty(id) || _.isNaN(_.toNumber(id))) return null;
    }

    const { ruleList } = this.props;
    const exist = ruleList.find((rule) => rule.id.toString() === id.toString());
    return _.isNil(exist);
  }

  handleChange(e, key) {
    const stateData = {};
    if (key === "id") {
      stateData.idCheckResult = this.handleCheckId(e.target.value);
    }

    const value = e.target.value;
    this.setState({
      ...stateData,
      [key]: value,
    });

    this.handleUpdate(key, value);

    // let newRule = this.props.uprSetting;
    // newRule[key] = value;
    // this.props.handleCurrentRuleChanged(newRule);
  }

  handleTargetingChanged(targeting, key) {
    let { targetingSection } = this.state;
    targetingSection[key] = targeting;
    if (!targeting) {
      targetingSection = _.omit(targetingSection, key);
    }

    this.setState({
      targetingSection,
    });

    this.handleUpdate("targetingSection", targetingSection);
  }

  handleInventoryUnitsChanged(unitIds) {
    let { targetingSection } = this.state;
    _.set(targetingSection, ["inventory", "unitIds"], unitIds);
    // remove key-value if empty
    if (_.isEmpty(unitIds)) {
      _.unset(targetingSection, ["inventory", "unitIds"]);
    }
    this.setState({ targetingSection });

    this.handleUpdate("targetingSection", targetingSection);
  }

  handleInventoryExcludeUnitsChanged(unitIds) {
    let { targetingSection } = this.state;
    _.set(targetingSection, ["inventory", "excludedUnitIds"], unitIds);
    // remove key-value if empty
    if (_.isEmpty(unitIds)) {
      _.unset(targetingSection, ["inventory", "excludedUnitIds"]);
    }
    this.setState({ targetingSection });

    this.handleUpdate("targetingSection", targetingSection);
  }

  handleVirtualPlacementIdsChanged(virtualPlacementIds) {
    let { targetingSection } = this.state;
    _.set(
      targetingSection,
      ["inventory", "virtualPlacementIds"],
      virtualPlacementIds,
    );
    // remove key-value if empty
    if (_.isEmpty(virtualPlacementIds)) {
      _.unset(targetingSection, ["inventory", "virtualPlacementIds"]);
    }
    this.setState({ targetingSection });

    this.handleUpdate("targetingSection", targetingSection);
  }

  handlePlacementIdsChanged(e) {
    let idsString = e.target.value.replace(/\s+/g, "").split(",");
    idsString = _.uniq(_.compact(idsString));

    let { targetingSection } = this.state;
    _.set(targetingSection, ["inventory", "placementIds"], idsString);
    // remove key-value if empty
    if (_.isEmpty(idsString)) {
      _.unset(targetingSection, ["inventory", "placementIds"]);
    }

    this.setState({
      targetingSection,
      placementIdsString: e.target.value,
    });

    this.handleUpdate("targetingSection", targetingSection);
  }

  handlePlacementSelect(ids) {
    const { targetingSection } = this.state;
    const placementIds = _.uniq(ids);

    _.set(targetingSection, ["inventory", "placementIds"], placementIds);
    // remove key-value if empty
    if (_.isEmpty(placementIds)) {
      _.unset(targetingSection, ["inventory", "placementIds"]);
    }
    this.setState({
      targetingSection,
      placementIdsString: placementIds.join(","),
      isOpenPlacementModal: false,
    });

    this.handleUpdate("targetingSection", targetingSection);
  }

  handlePriceTypeChanged(priceType) {
    let { priceSection } = this.state;
    priceSection.priceType = priceType;

    // LGO needs price = -1
    if (priceType === 2) {
      // priceSection = _.omit(priceSection, "price");
      priceSection.price = -1;
    }

    // no price setting
    if (priceType === -1) {
      priceSection = {
        priceType: -1,
        price: -1,
      };
    }

    this.setState({
      priceSection,
    });

    this.handleUpdate("priceSection", priceSection);
  }

  handlePriceChanged(price) {
    let { priceSection } = this.state;
    priceSection.price = price;
    this.setState({
      priceSection,
    });

    this.handleUpdate("priceSection", priceSection);
  }

  handleBrandPriceSettingsChanged(brandPriceSettings) {
    let { priceSection } = this.state;

    let newPriceSection = { ...priceSection };
    newPriceSection.brandedPriceSettings = brandPriceSettings;
    if (_.isEmpty(newPriceSection.brandedPriceSettings)) {
      newPriceSection = _.omit(newPriceSection, "brandedPriceSettings");
    }

    this.setState({
      priceSection: newPriceSection,
    });

    this.handleUpdate("priceSection", newPriceSection);
  }

  handleSelectChanged(selectedOption) {
    this.setState({ selectedId: selectedOption.value });
    this.handleImportUpr(selectedOption.value);
  }

  handleUpdate(key, value) {
    const { isBatch, selectedId, importData } = this.state;
    if (!this.props.handleCurrentRuleChanged) return;
    if (isBatch) {
      const newImportData = _.cloneDeep(importData);
      newImportData[selectedId][key] = value;
      this.setState({ importData: newImportData });
      this.props.handleCurrentRuleChanged({
        ...newImportData[selectedId],
        importId: selectedId,
      });
    } else {
      let newRule = this.props.uprSetting;
      newRule[key] = value;
      this.props.handleCurrentRuleChanged(newRule);
    }
  }

  handleLoading(isLoading) {
    if (this.props.handleLoading) {
      this.props.handleLoading(isLoading);
    }

    this.setState({
      isLoading,
    });
  }

  _addAutoImport(targetingSection, importData) {
    if (_.isNil(importData)) return _.cloneDeep(targetingSection);
    if (_.isNil(targetingSection)) return {};

    const config = _.cloneDeep(targetingSection);
    const customs = _.get(config, "customs", []);
    if (customs.length === 0) {
      customs.push([importData]);
    } else {
      _.forEach(customs, (list) => {
        const checkOpt = _.findIndex(list, (d) => d.keyId === importData.keyId);
        if (checkOpt < 0) {
          list.push(importData);
        }
      });
    }

    config.customs = customs;

    // Handle virtualPlacementIds add -2
    const virtualPlacementIds = _.get(
      config,
      ["inventory", "virtualPlacementIds"],
      [],
    );
    _.set(
      config,
      ["inventory", "virtualPlacementIds"],
      _.uniq([...virtualPlacementIds, -2]),
    );

    return config;
  }

  render() {
    const {
      networkId,
      networkInfo,
      modalType,
      placements,
      demandSource,
      ruleList,
    } = this.props;

    const {
      id,
      name,
      label,
      priceSection,
      targetingSection,
      placementIdsString,
      importUprId,
      importUprIdOptions,
      selectedId,
      importErrMsg,
      isLoading,
      isBatch,
      isOpenPlacementModal,

      idCheckResult,
    } = this.state;

    const selected = importUprIdOptions.find(
      (option) => option.value === selectedId,
    );

    const repeatRule =
      idCheckResult === false
        ? ruleList.find((rule) => rule.id.toString() === id.toString())
        : null;

    return (
      <div>
        <div className="rounded mb-4 bg-white px-8 pb-8 pt-6">
          {[MODAL_TYPE.ADD, MODAL_TYPE.COPY].includes(modalType) && (
            <>
              {isBatch ? (
                <div className="rounded mb-4 flex items-center gap-2 bg-blue-100 p-4">
                  <label
                    className="block font-bold text-gray-800"
                    htmlFor="importRuleId"
                  >
                    Import from UPR ID ({importUprIdOptions.length}):
                  </label>
                  <div className="w-56">
                    <Select
                      value={selected}
                      onChange={this.handleSelectChanged}
                      options={importUprIdOptions}
                      isDisabled={isLoading}
                    />
                  </div>
                </div>
              ) : (
                <div className="rounded mb-4 bg-blue-100 p-4">
                  <div className="flex items-center gap-2">
                    <div>
                      <label
                        className="block font-bold text-gray-800"
                        htmlFor="importRuleId"
                      >
                        Import from UPR External ID
                      </label>
                      <input
                        className={inputClass}
                        id="importRuleId"
                        type="number"
                        value={importUprId}
                        onChange={(e) => this.handleImportUprIdChanged(e)}
                      />
                    </div>
                  </div>
                  <button
                    className={buttonActionClass}
                    onClick={() => this.handleImportUpr(importUprId)}
                  >
                    Import
                  </button>
                  <div className="bg-red-200 px-4 font-semibold text-red-800">
                    {importErrMsg}
                  </div>
                </div>
              )}
            </>
          )}

          {isLoading ? (
            <LoadingUI></LoadingUI>
          ) : (
            <>
              <div className="mb-4">
                <label
                  className="block font-bold text-gray-800"
                  htmlFor="ruleId"
                >
                  ID
                </label>
                <div className="flex items-center gap-1">
                  <div className="w-1/3">
                    <input
                      className={
                        [MODAL_TYPE.ADD, MODAL_TYPE.COPY].includes(modalType)
                          ? inputClass
                          : inputClassDisabled
                      }
                      id="ruleId"
                      type="number"
                      value={id}
                      onChange={(e) => this.handleChange(e, "id")}
                      disabled={modalType === MODAL_TYPE.EDIT}
                    />
                  </div>
                  {!_.isNil(idCheckResult) && (
                    <>
                      {idCheckResult === true ? (
                        <SimpleTooltip tooltipText="ID is available">
                          <FaCheck className="text-green-600"></FaCheck>
                        </SimpleTooltip>
                      ) : (
                        <SimpleTooltip
                          tooltipText={`ID is already used by rule [${repeatRule.id} - ${repeatRule.name}]`}
                        >
                          <FaTimes className="text-red-600"></FaTimes>
                        </SimpleTooltip>
                      )}
                    </>
                  )}
                  <RuleListInformationButton ruleList={ruleList} />
                </div>
              </div>

              <div className="mb-4">
                <label className="block font-bold text-gray-800" htmlFor="name">
                  Name
                </label>
                <input
                  className={inputClass}
                  id="name"
                  type="text"
                  value={name}
                  onChange={(e) => this.handleChange(e, "name")}
                />
              </div>

              <div className="mb-4">
                <label
                  className="block font-bold text-gray-800"
                  htmlFor="label"
                >
                  Label (optional)
                </label>
                <input
                  className={inputClass}
                  id="label"
                  type="text"
                  value={label}
                  onChange={(e) => this.handleChange(e, "label")}
                />
              </div>

              <div className="border-t rounded mb-4 bg-gray-300 px-4 py-2">
                <div className="border-b mb-2 mt-2 text-lg font-bold">
                  Pricing
                </div>
                <div>
                  <PricingSectionControl
                    currency={networkInfo.currency}
                    priceSection={priceSection}
                    handlePriceChanged={this.handlePriceChanged}
                    handlePriceTypeChanged={this.handlePriceTypeChanged}
                  ></PricingSectionControl>
                </div>
              </div>

              <div className="border-t rounded mb-4 bg-gray-300 px-4 py-2">
                <div className="border-b mb-2 mt-2 text-lg font-bold">
                  Brand Price Settings
                </div>
                <div>
                  <BrandedPriceSettingsSection
                    networkId={networkInfo.networkId}
                    currency={networkInfo.currency}
                    brandedPriceSettings={priceSection.brandedPriceSettings}
                    demandSource={demandSource}
                    handleBrandPriceSettingsChanged={
                      this.handleBrandPriceSettingsChanged
                    }
                    handleIsEditing={this.props.handleIsEditing}
                  ></BrandedPriceSettingsSection>
                </div>
              </div>

              <div className="border-t rounded mb-4 bg-gray-300 px-4 py-2">
                <div className="border-b mt-2 text-lg font-bold">Targeting</div>
                <div className={targetingBlockClass}>
                  <div className={targetingTitleClass}>Inventory</div>
                  <div>
                    Unit IDs:{" "}
                    <span className="text-sm text-gray-700">
                      (you can also paste a list of "," separated <i>unitIds</i>{" "}
                      or <i>extGamUnitIds</i>)
                    </span>
                  </div>
                  <UnitsSelector
                    networkId={networkId}
                    handleChanged={this.handleInventoryUnitsChanged}
                    isCreatable={true}
                    selectedItems={
                      targetingSection.inventory
                        ? targetingSection.inventory.unitIds
                        : []
                    }
                  ></UnitsSelector>
                  <div className="text-xs text-gray-600">
                    {(targetingSection.inventory &&
                      targetingSection.inventory.unitIds &&
                      targetingSection.inventory.unitIds.length) ||
                      0}{" "}
                    unitIds
                  </div>

                  <div className="mt-2">
                    Exclude Unit IDs:{" "}
                    <span className="text-sm text-gray-700">
                      (you can also paste a list of "," separated <i>unitIds</i>{" "}
                      or <i>extGamUnitIds</i>)
                    </span>
                  </div>
                  <UnitsSelector
                    networkId={networkId}
                    handleChanged={this.handleInventoryExcludeUnitsChanged}
                    isCreatable={true}
                    selectedItems={
                      targetingSection.inventory
                        ? targetingSection.inventory.excludedUnitIds
                        : []
                    }
                  ></UnitsSelector>
                  <div className="text-xs text-gray-600">
                    Excluding{" "}
                    {(targetingSection.inventory &&
                      targetingSection.inventory.excludedUnitIds &&
                      targetingSection.inventory.excludedUnitIds.length) ||
                      0}{" "}
                    unitIds
                  </div>

                  <div className="mt-2 flex items-center justify-between">
                    <div>Placement IDs: ("," separated)</div>
                    <button
                      type="button"
                      className={buttonActionClassGray}
                      onClick={() => {
                        this.setState({ isOpenPlacementModal: true });
                      }}
                    >
                      Select from Resource Mapping
                    </button>
                  </div>
                  <textarea
                    className={inputClass}
                    id="placementIds"
                    rows="1"
                    value={placementIdsString}
                    onChange={this.handlePlacementIdsChanged}
                  ></textarea>
                  {targetingSection.inventory &&
                    (targetingSection.inventory.placementIds || []).length >
                      0 && (
                      <div
                        className="flex flex-wrap gap-1 overflow-y-auto bg-gray-200 p-2"
                        style={{ maxHeight: "200px" }}
                      >
                        {(targetingSection.inventory.placementIds || []).map(
                          (id) => {
                            const item = placements.find((p) => p.id === id);
                            return (
                              <div
                                key={id}
                                className={`border rounded border-gray-400 px-1 text-sm ${
                                  item ? "bg-blue-200" : "bg-red-200"
                                }`}
                              >
                                {id} {item ? item.props.type : "UNKNOWN"}
                              </div>
                            );
                          },
                        )}
                      </div>
                    )}
                  <div className="flex items-center gap-1 text-xs text-gray-600">
                    <div>
                      {(targetingSection.inventory &&
                        targetingSection.inventory.placementIds &&
                        targetingSection.inventory.placementIds.length) ||
                        0}{" "}
                      placements
                    </div>
                  </div>

                  <div className="mt-2">
                    Virtual Placement IDs:{" "}
                    <span className="text-sm text-gray-700">
                      (you can also paste a list of "," separated{" "}
                      <i>virtualPlacementIds</i>)
                    </span>
                  </div>
                  <VirtualPlacementSelector
                    networkId={networkId}
                    handleChanged={this.handleVirtualPlacementIdsChanged}
                    selectedItems={
                      targetingSection.inventory
                        ? targetingSection.inventory.virtualPlacementIds
                        : []
                    }
                  ></VirtualPlacementSelector>
                  <div className="text-xs text-gray-600">
                    {(targetingSection.inventory &&
                      targetingSection.inventory.virtualPlacementIds &&
                      targetingSection.inventory.virtualPlacementIds.length) ||
                      0}{" "}
                    virtualPlacementIds
                  </div>
                </div>

                {/* <div className={targetingBlockClass}>
                  <div className={targetingTitleClass}>GAM Inventory Types</div>
                  <GAMInventoryTypeSelector
                    handleChanged={(value) => {
                      return this.handleTargetingChanged(
                        value,
                        TARGETING_TYPE.INVENTORY_TYPES
                      );
                    }}
                    selectedItems={
                      targetingSection.inventory
                        ? targetingSection.inventoryTypes
                        : []
                    }
                  ></GAMInventoryTypeSelector>
                </div> */}

                <div className={targetingBlockClass}>
                  <div className={targetingTitleClass}>OS</div>
                  <TargetingWithInExControl
                    targetingType={TARGETING_TYPE.OS}
                    targeting={targetingSection[TARGETING_TYPE.OS]}
                    handleTargetingChanged={(t) =>
                      this.handleTargetingChanged(t, TARGETING_TYPE.OS)
                    }
                  ></TargetingWithInExControl>
                </div>

                <div className={targetingBlockClass}>
                  <div className={targetingTitleClass}>Device Category</div>

                  <TargetingWithInExControl
                    targetingType={TARGETING_TYPE.DC}
                    targeting={targetingSection[TARGETING_TYPE.DC]}
                    handleTargetingChanged={(t) =>
                      this.handleTargetingChanged(t, TARGETING_TYPE.DC)
                    }
                  ></TargetingWithInExControl>
                </div>

                <div className={targetingBlockClass}>
                  <div className={targetingTitleClass}>Country</div>
                  <TargetingWithInExControl
                    targetingType={TARGETING_TYPE.COUNTRY}
                    targeting={targetingSection[TARGETING_TYPE.COUNTRY]}
                    handleTargetingChanged={(t) =>
                      this.handleTargetingChanged(t, TARGETING_TYPE.COUNTRY)
                    }
                  ></TargetingWithInExControl>
                </div>

                <div className={targetingBlockClass}>
                  <div className={targetingTitleClass}>Browser</div>
                  <TargetingWithInExControl
                    targetingType={TARGETING_TYPE.BROWSER}
                    targeting={targetingSection[TARGETING_TYPE.BROWSER]}
                    handleTargetingChanged={(t) =>
                      this.handleTargetingChanged(t, TARGETING_TYPE.BROWSER)
                    }
                  ></TargetingWithInExControl>
                </div>

                <div className={targetingBlockClass}>
                  <div className={targetingTitleClass}>Inventory Types</div>
                  <TargetingWithInExControl
                    onlyIncludes={true}
                    targetingType={TARGETING_TYPE.INVENTORY_TYPES}
                    targeting={targetingSection[TARGETING_TYPE.INVENTORY_TYPES]}
                    handleTargetingChanged={(t) =>
                      this.handleTargetingChanged(
                        t,
                        TARGETING_TYPE.INVENTORY_TYPES,
                      )
                    }
                  ></TargetingWithInExControl>
                </div>

                <div className={targetingBlockClass}>
                  <div className={targetingTitleClass}>Video Positions</div>
                  <TargetingWithInExControl
                    onlyIncludes={true}
                    targetingType={TARGETING_TYPE.VIDEO_POSITIONS}
                    targeting={targetingSection[TARGETING_TYPE.VIDEO_POSITIONS]}
                    handleTargetingChanged={(t) =>
                      this.handleTargetingChanged(
                        t,
                        TARGETING_TYPE.VIDEO_POSITIONS,
                      )
                    }
                  ></TargetingWithInExControl>
                </div>

                <div className={targetingBlockClass}>
                  <div className={targetingTitleClass}>Inventory Format</div>
                  <TargetingWithInExControl
                    targetingType={TARGETING_TYPE.INVENTORY_FORMAT}
                    targeting={
                      targetingSection[TARGETING_TYPE.INVENTORY_FORMAT]
                    }
                    handleTargetingChanged={(t) =>
                      this.handleTargetingChanged(
                        t,
                        TARGETING_TYPE.INVENTORY_FORMAT,
                      )
                    }
                  ></TargetingWithInExControl>
                </div>

                <div className={targetingBlockClass}>
                  <div className={targetingTitleClass}>Inventory URL</div>
                  <TargetingWithInExControl
                    networkId={networkId}
                    targetingType={TARGETING_TYPE.INVENTORY_URL}
                    targeting={targetingSection[TARGETING_TYPE.INVENTORY_URL]}
                    handleTargetingChanged={(t) =>
                      this.handleTargetingChanged(
                        t,
                        TARGETING_TYPE.INVENTORY_URL,
                      )
                    }
                  ></TargetingWithInExControl>
                </div>

                <div className={targetingBlockClass}>
                  <div className={targetingTitleClass}>Mobile Application</div>
                  <TargetingWithInExControl
                    networkId={networkId}
                    targetingType={TARGETING_TYPE.MOBILE_APPLICATION}
                    targeting={
                      targetingSection[TARGETING_TYPE.MOBILE_APPLICATION]
                    }
                    handleTargetingChanged={(t) =>
                      this.handleTargetingChanged(
                        t,
                        TARGETING_TYPE.MOBILE_APPLICATION,
                      )
                    }
                  ></TargetingWithInExControl>
                </div>

                <div className={targetingBlockClass}>
                  <div className={targetingTitleClass}>
                    Customs (
                    {targetingSection[TARGETING_TYPE.CUSTOMS]
                      ? targetingSection[TARGETING_TYPE.CUSTOMS].length
                      : 0}
                    )
                  </div>
                  <div className="bg-gray-200 p-2">
                    <CustomSetTargetingControlV2
                      networkId={networkId}
                      handleIsEditing={this.props.handleIsEditing}
                      targeting={targetingSection[TARGETING_TYPE.CUSTOMS]}
                      handleValueChanged={(t) =>
                        this.handleTargetingChanged(t, TARGETING_TYPE.CUSTOMS)
                      }
                    ></CustomSetTargetingControlV2>
                  </div>
                </div>
              </div>
            </>
          )}

          {isOpenPlacementModal && (
            <NetworkPlacementModal
              selected={
                (targetingSection.inventory &&
                  targetingSection.inventory.placementIds) ||
                []
              }
              placements={placements}
              handleClose={() => {
                this.setState({ isOpenPlacementModal: false });
              }}
              handleConfirm={this.handlePlacementSelect}
            ></NetworkPlacementModal>
          )}
        </div>
      </div>
    );
  }
}

class RuleListInformationButton extends React.Component {
  constructor(props) {
    super(props);

    this.state = {
      isOpenModal: false,
    };
  }

  render() {
    const { ruleList } = this.props;
    const { isOpenModal } = this.state;

    return (
      <>
        <button
          type="button"
          className={`${buttonActionClassGray} ml-2 text-xs`}
          onClick={() => {
            this.setState({ isOpenModal: true });
          }}
        >
          Check Rule Info
        </button>

        <PromptModal
          header="Existing Rule Information"
          isOpenModal={isOpenModal}
          msg={["", MESSAGE.SUCCESS]}
          handleClose={() => {
            this.setState({ isOpenModal: false });
          }}
        >
          <SimpleDataTable
            items={ruleList}
            columns={[
              {
                label: "ID",
                key: "id",
                className: "w-48 tabular-nums",
                style: { textAlign: "right" },
              },
              {
                label: "Name",
                key: "name",
                style: { textAlign: "left" },
              },
            ]}
          />
        </PromptModal>
      </>
    );
  }
}

export default NetworkCustomUPRForm;
